module.exports = __webpack_public_path__ + "img/icon_pdf.fb48f4a1.svg";